import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionsModalComponent } from './actions-modal.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
    declarations: [ActionsModalComponent],
    imports: [
        CommonModule,
        SharedModule,
        ReactiveFormsModule,
    ], schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ActionsModalModule { }
